<script setup>
import { nextTick, onMounted, ref, defineEmits } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { validateForms, reqString, schemaMaker } from '@valid/JoiValidation'
import { searchCustomers } from '@service/CustomerService'

const emit = defineEmits(['done'])
const router = useRouter()
const store = useStore()
const btnLoading = ref(null)
const input = ref(null)

// input autofocus on mounting
onMounted(() => {
  nextTick(() => {
    input.value.$el.querySelector('input').focus()
    setTimeout(() => window.scrollTo({ top: 400 }), 100)
  })
})

// define form
const customerName = ref('')
const validName = schemaMaker({
  name: reqString('نام مشتری')
})

const submitForm = async () => {
  if (btnLoading.value) return
  const errors = validateForms({ name: customerName.value }, validName)
  if (errors) return store.dispatch('displayErrors', errors)

  btnLoading.value = true
  const query = { type: 1, name: customerName.value }
  try {
    const { data } = await searchCustomers(query)
    if (data.count === 0) {
      store.dispatch('addToast', {
        type: 'error',
        message: 'مشتری ثبت نشده است.'
      })
      emit('done')
    } else {
      store.dispatch('customer/setCustomers', data.results)
      router.push({
        name: 'CustomerSearch',
        query: { type: 1, name: customerName.value }
      })
      emit('done')
    }
  } catch (ex) {
    store.dispatch('addToast', {
      type: 'error',
      message: 'درخواست شما موفقیت‌آمیز نبود.'
    })
  } finally {
    btnLoading.value = false
  }
}
</script>

<template>
  <form novalidate class="modal-form-wrapper" @submit.prevent="submitForm">
    <div class="footer-modal">
      <h4 class="footer-modal__text">
        نام مشتری
      </h4>
    </div>
    <base-input
      animate-type="remove"
      label="نام مشتری"
      ref="input"
      v-model="customerName"
    />
    <div class="credit-buttons">
      <button type="submit" class="button button--black">
        <svg
          style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd;width: 34px; height:34px"
          viewBox="0 0 512 512"
          class="button__icon"
          v-show="!btnLoading"
        >
          <path
            fill="#c69d4e"
            d="M489.4 508.14c5.14,5.14 13.6,5.15 18.74,0 5.15,-5.14 5.15,-13.6 0,-18.74l-135.98 -135.98 4.24 -5.12c16.92,-20.36 29.89,-43.69 38.19,-68.83 8.03,-24.31 11.58,-50.04 10.51,-75.62 -2.23,-53.42 -24.28,-103.75 -62.09,-141.57 -83.05,-83.04 -217.68,-83.04 -300.73,0 -83.04,83.05 -83.04,217.69 0,300.73 37.82,37.81 88.15,59.86 141.57,62.09 25.58,1.07 51.3,-2.48 75.62,-10.51 25.14,-8.3 48.46,-21.27 68.83,-38.19l5.11 -4.24 135.99 135.98zm-145.47 -426.78c72.51,72.51 72.51,190.07 0,262.57 -72.51,72.51 -190.06,72.51 -262.57,0 -72.5,-72.5 -72.5,-190.06 0,-262.57 72.51,-72.5 190.07,-72.5 262.57,0z"
          />
        </svg>
        <spinner v-if="btnLoading" />
      </button>
    </div>
  </form>
</template>
